import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { InsightsKendoPage } from '@/pages/analysis/insights-kendo';
import { useFeatureFlag } from '@/hooks';

export const InsightsKendoRouteGuard = () => {
  const isWorkInProgress = useFeatureFlag('work-in-progress');
  const params = useParams();
  const inspection = params['inspection'];

  if (!isWorkInProgress) {
    // Redirect to classic insights if feature flag not enabled
    return <Navigate to={`/analysis/${inspection}/insights`} replace />;
  }

  return <InsightsKendoPage />;
};
